<template>
    <div class="fade-animation content-gebaeude">
        <h4 class="mt-3">Gebäude und Dach Informationen</h4>
        <div class="karten-halter mt-2">
            <Gebaeudegrafik />
        </div>
        <div class="karten-halter mt-2">
            <component v-if="dachform != ''" v-bind:is="dachform+'Seitenansicht'"></component>
        </div>
    </div>
</template>


<script>
import { mapState } from "vuex";
import Gebaeudegrafik from "../svg/Gebaeudegrafik";
import Satteldach from "../svg/Satteldach";
import Pultdach from "../svg/Pultdach";
import Walmdach from "../svg/Walmdach";
import SatteldachSeitenansicht from "../svg/SatteldachSeitenansicht";
import PultdachSeitenansicht from "../svg/PultdachSeitenansicht";
import WalmdachSeitenansicht from "../svg/WalmdachSeitenansicht";

export default {
    name: 'Gebaeude',
    components: {
        Gebaeudegrafik,
        Satteldach,
        Pultdach,
        Walmdach,
        SatteldachSeitenansicht,
        PultdachSeitenansicht,
        WalmdachSeitenansicht
    },
    computed: {
        ...mapState({
            dachform: state => state.inputs.dachform,
        })
    },
    methods:{

    }
}
</script>

<style scoped>
    h4 {
        font-size: 1.3em
    }
    .karten-halter
    {
        margin: 5px 10px 10px 10px;
        float: left;
        height: 30%;
    }
    .content-gebaeude
    {
        height: 90vh;
    }

@media (max-width:992px) {
    h4 {
        font-size: 1.1em
    }

    .content-gebaeude
    {
        height: 30vh;
    }

    .karten-halter
    {
        height: 60%;
        max-width: 40%;
        margin: 5px 10px 10px 10px;
    }

}



.fade-animation
{
    animation: fadein 1s;
    -moz-animation: fadein 1s; /* Firefox */
    -webkit-animation: fadein 1s; /* Safari and Chrome */
    -o-animation: fadein 1s; /* Opera */
}
@keyframes fadein {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-moz-keyframes fadein { /* Firefox */
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-webkit-keyframes fadein { /* Safari and Chrome */
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-o-keyframes fadein { /* Opera */
    from {
        opacity:0;
    }
    to {
        opacity: 1;
    }
}
</style>